import React from 'react';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/cliente">
        Cliente
      </MenuItem>
      <MenuItem icon="asterisk" to="/mensaje">
        Mensaje
      </MenuItem>
      <MenuItem icon="asterisk" to="/callback">
        Callback
      </MenuItem>
      <MenuItem icon="asterisk" to="/catalogo-institucion">
        Catalogo Institucion
      </MenuItem>
      <MenuItem icon="asterisk" to="/estatus">
        Estatus
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
